import { z } from 'zod';

import { ApiEndpointTags, type ImagoMpApiQueryBuilder } from '../imago-mp.types';
import { EntityState } from './entity-state';

const changeSubscriptionStateInputSchema = z.object({
    subscriptionId: z.uuid('Subscription ID is required'),
    tenantId: z.string().min(1, 'Tenant ID is required'),
    newState: z.enum(EntityState),
});

type ChangeSubscriptionStateInput = z.infer<typeof changeSubscriptionStateInputSchema>;

export const changeSubscriptionStateMutation = (builder: ImagoMpApiQueryBuilder) =>
    builder.mutation<unknown, ChangeSubscriptionStateInput>({
        query: ({ subscriptionId, newState, tenantId }) => {
            changeSubscriptionStateInputSchema.parse({ subscriptionId, newState, tenantId });
            const params = new URLSearchParams({ tenantId });
            const queryString = params.toString();
            return {
                url: `/mp/1/chgsubstate?${queryString}`,
                method: 'put',
                body: { sid: subscriptionId, state: newState },
            };
        },
        invalidatesTags: (_results, _error, { subscriptionId }) => [
            { type: ApiEndpointTags.Subscription, id: subscriptionId },
            ApiEndpointTags.Subscriptions,
        ],
    });
